import './newlanding.css'
import { CinematicHero } from './components/CinematicHero'
import { ClosingCta } from './components/ClosingCta'
import { CommunityTrips } from './components/CommunityTrips'
import { ExploreGlobe } from './components/ExploreGlobe'
import Footer from '../../components/layout/Footer'
import { HowItWorks } from './components/HowItWorks'
import { JourneyShowcase } from './components/JourneyShowcase'
import { WhyChoose } from './components/WhyChoose'

/**
 * Ported as-is from animations-of-scrolling-test/src/App.jsx. Wrapped in
 * .newlanding-page so newlanding.css's scoped tokens/base styles apply here
 * only, not site-wide — this is an SPA, and a loaded stylesheet never
 * unloads on client-side navigation, so unscoped rules from the source
 * project's index.css (which targeted body/h1-h4/:focus-visible/:root
 * directly) would silently change fonts, heading color and focus rings on
 * every other page for the rest of the session. Pricing.jsx exists in this
 * port (matching the source) but stays unmounted, same as upstream:
 * intentionally not wired into the section list below.
 *
 * The @theme block (brand, ink and accent color-scale tokens, the custom font)
 * lives in src/index.css, not in newlanding.css alongside the rest of this
 * page's styles. Reason: Tailwind v4 treats every `@import "tailwindcss"`
 * as its own independent build entry. newlanding.css was only ever linked
 * in via this file's plain JS `import './newlanding.css'` — it never had
 * its own `@import "tailwindcss"` — so Tailwind's engine never processed
 * the @theme block that originally lived there, and every brand, ink and
 * accent color-scale utility class silently failed to generate anywhere (confirmed
 * live: the hero CTA button rendered as a blank white pill, because its
 * bg-brand-600 utility produced zero CSS, leaving white text/icon
 * invisible against the white page background). Moving @theme into the
 * one already-working Tailwind entry fixed it. Verified via `grep -o` on
 * the built CSS that bg-brand-600 etc. actually generate now, and that a
 * pre-existing app-wide class (animate-check-flip) still generates
 * unchanged, confirming nothing else broke.
 *
 * Long prose comments inside these two CSS files (this one and
 * newlanding.css) turned out to trip Tailwind v4's lightweight CSS parser
 * in more than one way — first an apostrophe produced a build-breaking
 * "Unterminated string" error, and after removing apostrophes, the comment
 * text itself started leaking verbatim into the shipped, minified CSS
 * instead of being stripped (confirmed by grepping the dist output).
 * Functionally harmless either way — CSS's fault-tolerant parsing discards
 * malformed content up to the next real rule rather than corrupting what
 * follows — but shipping raw prose in production CSS is not acceptable,
 * so the explanation lives here instead and both CSS files now carry only
 * short, plain, special-character-free one-line comments.
 */
export default function NewLandingPage() {
  return (
    <>
      <div className="newlanding-page">
        <main>
          <CinematicHero />
          <HowItWorks />
          <ExploreGlobe />
          <WhyChoose />
          <JourneyShowcase />
          <CommunityTrips />
          <ClosingCta />
        </main>
      </div>
      {/* The site-wide Footer, deliberately outside .newlanding-page: this
          page's scoped tokens (fonts, ink/brand colours, heading styles) would
          otherwise apply to it and it would stop matching the footer every
          other page renders. The header is not rendered here at all — App.jsx
          shows the shared Navbar on this route like everywhere else. */}
      <Footer />
    </>
  )
}
